module.exports = require("@material-ui/core/Dialog");